import React from 'react'
import styled from 'styled-components'
import { RequestType } from '../constants'
import RadioButton from '../../radio-button'

const RequestTypeContainerElement = styled.div`
  display: flex;
  gap: 2rem;
`

function RequestTypeSelection({ requestType, handleRequestTypeChange }) {
  const onRequestTypeChange = (e) => handleRequestTypeChange(e.target.value)

  return (
    <RequestTypeContainerElement>
      <RadioButton
        value={RequestType.EMAIL}
        checked={requestType === RequestType.EMAIL}
        onChange={onRequestTypeChange}
        label="Send an email for me"
      />
      <RadioButton
        value={RequestType.LINK}
        checked={requestType === RequestType.LINK}
        onChange={onRequestTypeChange}
        label="Give me a link I can send the borrower"
      />
    </RequestTypeContainerElement>
  )
}
export default RequestTypeSelection
